const csvDateHeaderValueGetter = (headerName, injectables) => {
    const { timeZoneName, i18n } = injectables;
    return i18n.formatMessage(
        { id: 'app.campaigns.reports.grid.column.smartHeader', defaultMessage: headerName },
        { value: headerName, details: timeZoneName }
    );
};

export default csvDateHeaderValueGetter;
